import React, { useState, useEffect } from 'react';
import { fetchAbout } from '../services/strapi';

const About = () => {
  const [about, setAbout] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getAbout = async () => {
      try {
        setLoading(true);
        const data = await fetchAbout();
        console.log(data);
        setAbout(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    getAbout();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  const baseUrl = process.env.REACT_APP_API_URL ;
  console.log(about)
  // Handle both image and video URLs
  const imageUrl = about.media?.formats?.large?.url 
    ? `${baseUrl}${about.media.formats.large.url}` 
    : "/path/to/default-image.jpg";

    return (
        <>
        <div className='about-card'>
            <div className='about-card__image-container'>
                <img 
                    className="artist-card__image"
                    src={imageUrl} 
                    alt={about.title}
                />
            </div>
            <div className='about-card__content'>
                <h2 className='about-card__title'>{about.title}</h2>
                <div className='about-card__description'>{about.description}</div>
            </div>

        </div>
        </>
          );
    };
    
    export default About;